const absoluteUrlRegex = new RegExp('^https?://')

export const isAbsoluteURL = (url: string): boolean => {
  return !!(url && url.match && url.match(absoluteUrlRegex))
}
